import React from "react";
import { Box, Button } from "@mui/material";
import { useAdminUi } from "../../hooks/useAdminUi";

/**
 * Responsive segmented tab bar (no gradients).
 * @param {{ id: string, label: string }[]} tabs
 * @param {string} value - active tab id
 * @param {(id: string) => void} onChange
 * @param {'neutral' | 'primary'} variant - primary uses green accent (Info/Activity)
 * @param {boolean} fullWidth - stretch tabs equally (default true on xs via sx)
 */
export default function AdminTabBar({ tabs, value, onChange, variant = "neutral", fullWidth = true }) {
  const { tabBarSx, tabBarItemSx } = useAdminUi();

  if (!tabs?.length) return null;

  return (
    <Box sx={tabBarSx}>
      {tabs.map((tab) => {
        const active = value === tab.id;
        return (
          <Button
            key={tab.id}
            type="button"
            disableElevation
            onClick={() => onChange(tab.id)}
            sx={{
              ...tabBarItemSx(active, variant),
              ...(fullWidth
                ? {
                    flex: { xs: "1 1 0", sm: "0 1 auto" },
                    minWidth: { xs: 0, sm: 88 },
                  }
                : {}),
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </Box>
  );
}
